const api = {

    updateSpaceData(payload) {
        Swal.fire({

            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_update' ),
        }).then((result) => {

            if(!result.isConfirmed) {
                return false
            }
            util.displayLoading()
            util.setEventLivewire('updateSpaceData', payload)

        })
    },


    updateBuildingData(building_id, name, organization_id) {
        Swal.fire({
            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_update' ),
        }).then((result) => {

            if(!result.isConfirmed) {
                return false
            }

            util.displayLoading()
            util.setEventLivewire('updateBuildingData', {
                building_id: building_id,
                name: name,
                organization_id: organization_id
            })

        })
    },

    updateBuilding(building_id, name, floors) {
        Swal.fire({
            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_update' ),
        }).then((result) => {

            if(!result.isConfirmed) {
                return false
            }

            util.displayLoading()
            util.setEventLivewire('updateBuilding', {
                building_id: building_id,
                name: name,
                floors: floors
            })

        })
    },
    deleteBuilding(id){
        Swal.fire({
            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_delete' ),
        }).then((result) => {
            if(!result.isConfirmed) {
                return false
            }
            util.displayLoading()
            util.setEventLivewire('deleteBuilding',id)
        })
    },

    updateUserData(payload) {
        Swal.fire({

            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_update' ),
        }).then((result) => {

            if(!result.isConfirmed) {
                return false
            }
            util.displayLoading()
            util.setEventLivewire('updateUserData', payload)

        })
    },

    addSpaceLayout(rooms) {
        
        Swal.fire({

            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_update' ),
        }).then((result) => {

            if(!result.isConfirmed) {
                return false
            }
            util.displayLoading()
            util.setEventLivewire('addSpaceLayout', rooms)

        })
    },

    deleteSpaceLayout(id) {
        Swal.fire({

            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_delete' ),
        }).then((result) => {

            if(!result.isConfirmed) {
                return false
            }
            util.displayLoading()
            util.setEventLivewire('deleteSpaceLayout', {layout_id: id})
        })
    },


    updateSpaceUserData(payload) {
        Swal.fire({

            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_update' ),
        }).then((result) => {

            if(!result.isConfirmed) {
                return false
            }
            util.displayLoading()
            util.setEventLivewire('updateSpaceUserData', payload)

        })
    },

    updateOrganizationData(payload) {
        Swal.fire({

            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_update' ),
        }).then((result) => {

            if(!result.isConfirmed) {
                return false
            }
            util.displayLoading()
            util.setEventLivewire('updateOrganizationData', payload)

        })
    },

    updatePassManagementData(payload) {
        Swal.fire({

            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_update' ),
        }).then((result) => {

            if(!result.isConfirmed) {
                return false
            }
            util.displayLoading()
            util.setEventLivewire('updatePassManagementData', payload)

        })
    },

    removeOrganizationOwner(payload) {
        Swal.fire({

            title: i18next.t( 'are_you_sure' ),
            html: i18next.t( 'you_wont_be_able_to_revert_this' ),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: i18next.t( 'cancel' ),
            confirmButtonText: i18next.t( 'yes_I_want_to_update' ),
        }).then((result) => {

            if(!result.isConfirmed) {
                return false
            }
            util.setEventLivewire('removeOrganizationOwner', payload)
        })
    }
}

export default api;
